export default [
    { id: "1", label: "My Components" },
    { id: "2", label: "Microtica Components" }
];